export default __webpack_public_path__ + "navigation-examples-location-snapping-960-834c6c08b5479b01148a84a0e144c69a.webp";